import loginBackground from './loginBackground.png';

export {
    loginBackground,
}